import {assetDimensions} from './asset-dimensions';

export function mediaBlocks2x() {
	// console.log("media blocks 2x script");
	// console.log("----------------------");
	// console.log(" ");

	const mediaBlock2x = document.querySelectorAll('.x2');

	for (var blockIndex = 0; blockIndex < mediaBlock2x.length; blockIndex++) {
		console.log("loop BLOCK: ", mediaBlock2x[blockIndex]);

		let heights = [];
		let widths = [];

		const items = mediaBlock2x[blockIndex].querySelectorAll('.media-item');
		const mbImages = mediaBlock2x[blockIndex].querySelectorAll('.media-item > img');
		const mbVideos = mediaBlock2x[blockIndex].querySelectorAll('video');
		
		// console.log("mbImages", mbImages);
		// console.log("mbVideos", mbVideos);
	
		for (var index = 0; index < mbImages.length; index++) {
			// console.log("loop img: ", index);
	
			const dimensions = assetDimensions(mbImages[index]);
			heights[index] = dimensions.height;
			widths[index] = dimensions.width;
			// console.log("📥 width: " + dimensions.width + ", height: " + dimensions.height + ", ratio: " + dimensions.ratio);
		}
	
		for (var index = 0; index < mbVideos.length; index++) {
			// console.log("loop vid: ", index);
			// Ensure no existing items in the array are overwritten
			const indexShift = index + mbImages.length;
	
			const dimensions = assetDimensions(mbVideos[index]);
			heights[indexShift] = dimensions.height;
			widths[indexShift] = dimensions.width;
			// console.log("📥 width: " + dimensions.width + ", height: " + dimensions.height + ", ratio: " + dimensions.ratio);
		}

		// console.log("heights: ", heights);
		const tallestHeight = Math.max.apply(Math, heights);
		let viewportHeight = window.innerHeight * 0.9;
		// console.log("tallestHeight: ", tallestHeight);

		for (var index = 0; index < mbVideos.length; index++) {

			// console.log("viewportHeight: ", viewportHeight);
			// console.log("tallestHeight: ", tallestHeight);

			if (viewportHeight < tallestHeight) {
				mbVideos[index].style.height = viewportHeight + "px";
			} else {
				mbVideos[index].style.height = tallestHeight + "px";
			}

		}
	
		for (var index = 0; index < mbImages.length; index++) {

			// console.log("viewportHeight: ", viewportHeight);
			// console.log("tallestHeight: ", tallestHeight);

			if (viewportHeight < tallestHeight) {
				mbImages[index].style.height = viewportHeight + "px";
			} else {
				mbImages[index].style.height = tallestHeight + "px";
			}

		}
	
		// console.log("heights: ", heights);
		const shortestHeight = Math.min.apply(Math, heights);
		//console.log("shortestHeight: ", shortestHeight);

		// console.log("widths: ", widths);
		function add(accumulator, a) {
			return accumulator + a;
		}
		const totalWidth = widths.reduce(add, 0) + 72; // with initial value to avoid when the array is empty
		//console.log("totalWidth: ", totalWidth);

		const blockRatio = shortestHeight / totalWidth * 100;
		//console.log("blockRatio: ", blockRatio);

		for (var index = 0; index < items.length; index++) {

			// @todo: my calculations above appear to be slightly off. Fix and remove the hack below
			const tweakedBlockRatio = blockRatio - 2; // Manual hack to slighlt shorten the crop to ensure the rounded corners look nice
			items[index].style.maxHeight = tweakedBlockRatio + "vw";
			//console.log("item: ", items[index]);
		}

		//console.log(" ");
	}

}